<template>
    <div class="form-group">
        <label :for="getFieldId" v-if="!withPlaceholder" v-text="placeholder"></label>
        <input class="form-control"
               :type="type"
               :value="value"
               :name="name"
               :id="getFieldId"
               :required="required"
               :pattern="pattern"
               :readonly="readonly"
               :disabled="disabled"
               :placeholder="printPlaceholder"
               :autocomplete="autocomplete"
               :maxlength="maxlength"
               @input="updateValue($event.target.value)"
               @change="updateValue($event.target.value, 'change')"
               @focus="updateValue($event.target.value, 'focus')"
               @blur="updateValue($event.target.value, 'blur')"
               @keyup="updateValue($event.target.value, 'keyup')"
               ref="input">
    </div>
</template>
<script>
    let Input = require('@/mixins/InputField')

    export default {

        mixins: [Input],

        props: {
            type: {
                type: String,
                required: false,
                default: 'text',
            },
        }
    }
</script>
